































import { Component } from 'vue-property-decorator';
import { Store } from '@/enums/Store';
import { User } from '@/util/User';
import { Member } from '@/util/Member';
import { Option } from '@/util/Option';
import { namespace } from 'vuex-class';
import FormGroup from '@/components/Form/InputComponents/FormGroup.vue';
import FormSelect from '@/components/Form/InputComponents/FormSelect.vue';
import FormInput from '@/components/Form/InputComponents/FormInput.vue';
import FormSwitch from '@/components/Form/InputComponents/FormSwitch.vue';
import BaseUserForm from '@/components/Form/BaseUserForm.vue';
import AddressForm from '@/components/Form/AddressForm.vue';
import AdditionalInformationForm from '@/components/Form/AdditionalInformationForm.vue';
import Validatable from '@/components/Validatable.vue';
import { NamedOption } from '@/util/NamedOption';

const MEMBER = namespace(Store.MEMBER);
const INVOICE_RECIPIENT = namespace(Store.INVOICE_RECIPIENT);

@Component({
  components: {
    AddressForm,
    BaseUserForm,
    FormInput,
    FormSelect,
    FormGroup,
    FormSwitch,
    AdditionalInformationForm
  }
})
export default class BillingAddress extends Validatable {
  @INVOICE_RECIPIENT.State('invoiceRecipient') invoiceRecipient!: User;
  @INVOICE_RECIPIENT.State('hasForeignInvoiceRecipient')
  hasForeignInvoiceRecipient!: boolean;
  @INVOICE_RECIPIENT.Mutation('SET_INVOICE_RECIPIENT') setInvoiceRecipient!: (
    user: User
  ) => void;
  @INVOICE_RECIPIENT.Action('setInvoiceRecipient') setInvoiceRecipientById!: (
    id?: string
  ) => void;
  @INVOICE_RECIPIENT.Action('setHasForeignInvoiceRecipient')
  setHasForeignInvoiceRecipient!: (value: boolean) => void;
  @MEMBER.State('members') members!: Member[];
  @MEMBER.Getter('memberById') getMember!: (id: string) => Member;
  switchOption!: NamedOption;
  isInvoiceRecipientCustomer = true;
  invoiceRecipientOptions: Option[] = [];

  created(): void {
    this.invoiceRecipientId = this.members[0].id;
    this.switchOption = new NamedOption(
      this.$t('foreign-invoice-recipient').toString(),
      true,
      'foreign-invoice-recipient'
    );

    for (const member of this.members) {
      const option = new Option(`${member.firstname} ${member.lastname}`, member.id);

      this.invoiceRecipientOptions.push(option);
    }
  }

  set isForeignInvoiceRecipient(value: boolean) {
    this.invoiceRecipientId = '';
    this.setHasForeignInvoiceRecipient(value);
    if (!value) {
      const user = this.members[0];
      this.setInvoiceRecipientById(user.id);
    }
  }
  get isForeignInvoiceRecipient() {
    return this.hasForeignInvoiceRecipient;
  }
  set invoiceRecipientSync(user: User) {
    this.setInvoiceRecipient(user);
  }
  get invoiceRecipientSync() {
    return this.invoiceRecipient;
  }

  set invoiceRecipientId(id: string) {
    this.setInvoiceRecipientById(id);
  }

  get invoiceRecipientId() {
    return this.invoiceRecipient.id;
  }

  get isOnlyOneMember() {
    return this.members.length == 1;
  }
}
